import React, { useEffect } from "react";
import PatientInsightsData from "../components/PatientInsightsData";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";

const PatientInsights = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <PatientInsightsData />
      </div>
    </div>
  );
};

export default PatientInsights;
